<script setup>
import { ref } from "vue";

defineProps({
  email: {
    type: String,
    default: null,
  },
});

const justCopied = ref(false);

const copyTextToClipboard = (text) => {
  justCopied.value = true;
  navigator.clipboard.writeText(text).then(() => {
    setTimeout(() => justCopied.value = false, 3000);
  });
};
</script>

<template>
  <el-tooltip
    :content="justCopied ? 'Copied' : 'Click to copy the email'"
    :open-delay="250"
  >
    <img
      class="clickable"
      :src="require('@/assets/images/candidate-card/email.svg')"
      @click.stop="copyTextToClipboard(email)"
    />
  </el-tooltip>
</template>
